import { Component } from '@angular/core';
import { DialogConfig } from '@ddt-web/dialog';
import { TreeNodeMap } from '@ddt-web/domain';

@Component({
	templateUrl: './view-blend-structure-dialog.component.html',
	styleUrls: ['./view-blend-structure-dialog.component.scss']
})
export class ViewBlendStructureDialogComponent {
	public treeNodeMap: TreeNodeMap;
	public portfolioId: string;

	constructor(public config: DialogConfig) {
		this.treeNodeMap = config.data.treeNodeMap;
		this.portfolioId = config.data.portfolioId;
	}

}

